module.exports = __webpack_public_path__ + "img/receipt.ce0583c0.svg";